import { Component, OnInit } from '@angular/core';
import { environment } from 'environments/environment';

@Component({
  selector: 'app-document-footer',
  templateUrl: './document-footer.component.html',
  styleUrls: ['./document-footer.component.css']
})
export class DocumentFooterComponent implements OnInit {
  year: number;
  triconDomain = environment.triconDomain;
  constructor() {
    this.year = new Date().getFullYear();
  }

  ngOnInit(): void {
  }

}
